export default {
  standard: 'standard',
  special: 'special',
  makeup: 'makeup',
}
